import { useIntl } from 'react-intl';

export const useCohortAttritionTableMessageKeys = () => {
  const intl = useIntl();

  return {
    criterion: intl.formatMessage({ id: 'projects.cohortAttritionTable.criterion' }),
    patientsRemaining: intl.formatMessage({
      id: 'projects.cohortAttritionTable.patientsRemaining',
    }),
    patientsRemainingPercent: intl.formatMessage({
      id: 'projects.cohortAttritionTable.patientsRemainingPercent',
    }),
    patientsExcluded: intl.formatMessage({ id: 'projects.cohortAttritionTable.patientsExcluded' }),
    patientsExcludedPercent: intl.formatMessage({
      id: 'projects.cohortAttritionTable.patientsExcludedPercent',
    }),

    defaultEmptyMessage: intl.formatMessage({ id: 'projects.cohortAttritionTable.noResults' }),
    loadingTitle: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.loadingTitle',
    }),
    emptyMessageTitle: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.title',
    }),
    draftCohortEmptyMessage: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.draft',
    }),
    processingCohortEmptyMessage: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.processing',
    }),
    errorCohortEmptyMessage: intl.formatMessage({
      id: 'projects.cohortAttritionTable.workflowMessage.error',
    }),

    patientsRemainingTooltip: intl.formatMessage({
      id: 'projects.cohortAttritionTable.patientsRemainingTooltip',
    }),
    patientsExcludedTooltip: intl.formatMessage({
      id: 'projects.cohortAttritionTable.patientsExcludedTooltip',
    }),
  };
};
